import {post_data} from './API_Calls.js';
import * as RO from './ReportObjects';
import * as RP from './ReportPlots';
import * as G from './General';

function normaliseAreaType(areaType) {
	if (typeof areaType !== "string") return "";
	return areaType.trim().toLowerCase();
}

export function getUrlParameters(){
    const url = new URL(window.location.href);

    const date_from = url.searchParams.get('date_from') ? new Date(url.searchParams.get('date_from')) : null;
    const date_to = url.searchParams.get('date_to') ? new Date(url.searchParams.get('date_to')) : null;
    const imo = url.searchParams.get('imo');
    const mmsi = url.searchParams.get('mmsi');
    const vesselUuid = url.searchParams.get('vesselUuid') ? url.searchParams.get('vesselUuid') : null;
    const return_data = { date_from : date_from, date_to: date_to, imo: imo, mmsi: mmsi, vesselUuid: vesselUuid}
    return return_data;
}

export async function GetVesselHistoricPositions(vessel_uuids, vessel_imos, vessel_mmsi, granularity, date_from, date_to,
    mercury = false, box_id = "", satc = false, local_ais = false, remote_ais = true){

    let results = [];

    if (granularity === "h") {
        const intervals = splitIntoQuarterlyIntervals(date_from, date_to);

        for (const [from, to] of intervals) {
            const param = {
                vessel_imos: vessel_imos ? [vessel_imos] : [],
                vessel_mmsis: vessel_mmsi ? [vessel_mmsi] : [],
                vessel_uuids: vessel_uuids ? [vessel_uuids] : [],
                granularity,
                date_from: from.toISOString().split(".")[0],
                date_to: to.toISOString().split(".")[0],
                include_satc: satc,
                include_local_ais: local_ais,
                include_remote_ais: remote_ais,
                include_mercury: mercury,
                mercury_box_id: box_id,
                user_account_uuid: RO.current_user,
            };

            const res = await post_data("/get_VesselTrackData", param);
            if (res) results.push(...res); // adjust depending on res structure
        }
    } else {
        const param = {
            vessel_imos: vessel_imos ? [vessel_imos] : [],
            vessel_mmsis: vessel_mmsi ? [vessel_mmsi] : [],
            vessel_uuids: vessel_uuids ? [vessel_uuids] : [],
            granularity,
            date_from: date_from?.toISOString().split(".")[0],
            date_to: date_to?.toISOString().split(".")[0],
            include_satc: satc,
            include_local_ais: local_ais,
            include_remote_ais: remote_ais,
            include_mercury: mercury,
            mercury_box_id: box_id,
            user_account_uuid: RO.current_user,
        };

        const res = await post_data("/get_VesselTrackData", param);
        if (res) results.push(...res);
    }
    const EMPTY_UUID = "00000000-0000-0000-0000-000000000000";
    try {
        let vesselHistory = results.map((i, index) => {
            if (i.vessel_uuid === EMPTY_UUID) {
                return {...i, date_received: new Date(i.date_received), vessel_uuid: vessel_uuids, row: index};
            }
            return i;
        });

        vesselHistory.sort((a, b) => a.date_received - b.date_received);

        const firstCutoff = new Date(date_from);
        firstCutoff.setDate(firstCutoff.getDate() - 3);

        const firstIndex = vesselHistory.findIndex(x => x.date_received > firstCutoff) - 1;

        if (firstIndex > 0) vesselHistory.splice(0, firstIndex);

        const lastCutoff = new Date(date_to);
        lastCutoff.setDate(lastCutoff.getDate() + 3);

        const lastIndex = vesselHistory.findIndex(x => x.date_received > lastCutoff);
        if (lastIndex !== -1) vesselHistory.splice(lastIndex);

        return removeOutlierPositions(vesselHistory, granularity);
    }
    catch (error) {
        console.error(error);
        return null;
    }
}

function splitIntoQuarterlyIntervals(startDate: Date, endDate: Date): [Date, Date][] {
    const intervals: [Date, Date][] = [];
    let current = new Date(startDate);

    while (current < endDate) {
        const next = new Date(current);
        next.setMonth(current.getMonth() + 3);
        if (next > endDate) next.setTime(endDate.getTime());
        intervals.push([new Date(current), new Date(next)]);
        current = new Date(next);
    }

    return intervals;
}

function removeOutlierPositions(vesselHistory, granularity){
    if(vesselHistory != null){
        var index_removal_list = [];
        vesselHistory.sort(function(a, b) {
          return a.date_received.getTime() - b.date_received.getTime();
        });

        for (var i = 0; i < (vesselHistory.length - 1); i++){
            if(i >= 1) {
                var result = G.filterPositions(vesselHistory[i], vesselHistory[i+1], vesselHistory[i-1], granularity);
                if(result) index_removal_list.push(i);
            }
        }
        vesselHistory = vesselHistory.filter((_, idx) => !index_removal_list.includes(idx));
        return vesselHistory;
    }
}
export async function checkSpacialAreasTimeline(data, start_date, end_date){
    var temp = data.filter(i => i.latitude != null && i.longitude != null && i.latitude !== '' && i.longitude !== '')
        .map(i => ({ position_id: i.date_received.toISOString(), position: { lat: i.latitude, lon: i.longitude }}));
    var combine_data_ids = data.filter(i => i.latitude != null && i.longitude != null && i.latitude !== '' && i.longitude !== '')
    .map(i => ({ row: i.row, position_id: i.date_received.toISOString(), position: { lat: i.latitude, lon: i.longitude }}));

    //console.log("parameters: ", {"position_list": temp});
    const res = await post_data("/checkAllSpacialAreasTimeline", {"position_list": temp}) || null;
    //console.log("checkSpacialAreasTimeline: ", res);
    var area_list = JSON.parse(res.position_areas);
    var position_areas_list = [];
    var total_journey_time = Math.abs(start_date - end_date);
    var total_journey_hours = Math.floor(total_journey_time / (1000 * 60 * 60));

    if (area_list) {
        for (const item of area_list) {
          position_areas_list.push(RO.formatSpacialArea(item));
        }
    }

    var timeline_list = JSON.parse(res.areas_timeline);
    var areas_timeline_list = [];
    if (area_list) {
        for (var item of timeline_list) {
          var timespan = Math.abs(new Date(item.start) - new Date(item.end));
          item.leg_hours =  Math.floor(timespan / (1000 * 60 * 60));
          item.journey_perc = (item.leg_hours / total_journey_hours) * 100

          areas_timeline_list.push(RO.formatAreaTimeline(item));
        }
    }

    var total_list = JSON.parse(res.areas_total);
    var areas_total_list = [];
    if (area_list) {
        for (const item of total_list) {
          areas_total_list.push(RO.formatAreaTotal(item));
        }
    }

    var combined = combine_data_ids.map((item) => {
        var position = data.filter(i => i.row == item.row && i.date_received.toISOString() == item.position_id);
        var area = position_areas_list.filter(i => i.position_id == item.position_id &&
        item.position.lat == i.position.dec.lat && item.position.lon == i.position.dec.lon);

        var combined_data:RO.PositionAreaTimeline =  {
            position: position[0],
            spacial_area: area[0]
        }
        return combined_data;
    });
    return {position_areas_list, areas_timeline_list, areas_total_list, combined};
}

export function generateTimelineCharts(areaTotal, firstPosDate, lastPosDate, removePies){
    const plotData = processAreas(areaTotal, firstPosDate, lastPosDate);
    let timelinePiePlotList: RO.AllZonePlots[] = [];
    let timelineBarPlotList: RO.AllZonePlots[] = [];
    let plotMargin = [20, 0, 0, 0];
    let plotMarginBar = [20, 0, 0, 0];
    let plotSizePie = [280, 280];
    let plotSizeBar = [830, 280];
    if(removePies) plotSizeBar = [1100, 280];

    for (const plot_item of plotData){
        timelinePiePlotList.push(RP.createPieChart(plot_item, plot_item.name + " Timeline", ["", "#000", 8], 8, plotSizePie, [20, 0, 20, 0]));
        let bar_data = [];
        for (let i = 0; i < plot_item.y.length; i++) {
            bar_data.push({ name: plot_item.y[i], x: plot_item.y[i], y: plot_item.x[i], color: plot_item.color[i]})
        }

        timelineBarPlotList.push(RP.createBarChart(
            bar_data, plot_item.name + " Timeline",
            [{name: "", tickAngle: 90}, {name: "", rangemode:"tozero"}],
             8, false, [0,0,0,0], plotSizeBar
        ));
    }

   return { pie_plots: timelinePiePlotList, bar_plots: timelineBarPlotList};
}

function processAreas(areaTotal, firstPosDate, lastPosDate) {
    const plots_json = {
      berth_name: { name: "Berth", data: { x: [], y: [] }, color: []},
      berthing_area_name: { name: "Port", data: { x: [], y: [] }, color: []},
      eez: { name: "EEZ", data: { x: [], y: [] }, color: []},
      houthi_area: { name: "Houthi Area", data: { x: [], y: [] }, color: []},
      jwc_zone: { name: "JWC Zone", data: { x: [], y: [] }, color: []},
      marpol_eca: { name: "MARPOL ECA", data: { x: [], y: [] }, color: []},
      marpol_garbage: { name: "MARPOL Garbage", data: { x: [], y: [] }, color: []},
      marpol_noxious_liquid: { name: "MARPOL Noxious Liquid", data: { x: [], y: [] }, color: []},
      marpol_oil: { name: "MARPOL Oil", data: { x: [], y: [] }, color: []},
      marpol_sewage: { name: "MARPOL Sewage", data: { x: [], y: [] }, color: []},
      port_name: { name: "Port Unwanted", data: { x: [], y: [] }, color: []},
      sea_zone: { name: "Sea Zone", data: { x: [], y: [] }, color: []},
    };
    areaTotal = areaTotal.map(i => ({
        ...i,
        area_type: normaliseAreaType(i.area_type),
        area_name: cleanAreaNames(i.area_name)
    }));
    for (const area_key in plots_json){
        const area_data = areaTotal.filter(i => normaliseAreaType(i.area_type) === area_key);

        if(area_data && area_data.length > 0){
            for (const area of area_data){
                plots_json[area_key].data.x.push((Math.round(area.total_hours * 10) / 10));
                plots_json[area_key].data.y.push(area.area_name);
                plots_json[area_key].color.push("#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0'));
            }
        }
        else{
            delete plots_json[area_key];
        }
    }
    const totalHours = Math.abs(new Date(lastPosDate) - new Date(firstPosDate)) / (1000 * 60 * 60);

    const plotDataset_list = Object.values(plots_json).map(({ name, data, color }) => {
        const hasNotIn = data.y.some(y => typeof y === "string" && y.toUpperCase().includes("NOT IN"));
        const total = data.x.reduce((sum, val) => sum + val, 0);
        if(!hasNotIn) {
            data.x.push((totalHours - total));

            if(name.includes("MARPOL")) data.y.push("NOT IN ANNEX");
            else data.y.push("NOT IN "+ name.toUpperCase());

            color.push("#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0'));
        }
        const sortedData = data.x.map((xValue, index) => ({
            x: xValue,
            y: data.y[index],
            color: color[index] // Assuming colors array is of same length
        })).sort((a, b) => b.x - a.x); // Sorting by x value in ascending order

        const sortedX = sortedData.map(item => item.x);
        const sortedY = sortedData.map(item => item.y);
        const sortedColor = sortedData.map(item => item.color);
        return {
            name,
            x: sortedX,
            y: sortedY,
            color: sortedColor
        };
    });
    return plotDataset_list;
}
export function cleanAreaNames(name){
    if (typeof name !== "string") return "";

    const tidyPatterns = [
        [/BERTHING AREA/gi, "PORT"],
        [/EXCLUSIVE ECONOMIC ZONE/gi, "EEZ"],
        [/ANNEX /gi, "A-"]
    ];

    for (const [pattern, replacement] of tidyPatterns) {
        name = name.replace(pattern, replacement);
    }

    return name;
}

export function removeNotInDataPie(timelinePlot){
    const pieData = timelinePlot.plot_data.data[0];

    if (pieData && Array.isArray(pieData.labels) && Array.isArray(pieData.values)) {
        const filteredIndices = pieData.labels
            .map((label, i) => ({ label, i }))
            .filter(({ label }) => !label.toUpperCase().includes("NOT IN"))
            .map(({ i }) => i);

        const filteredLabels = filteredIndices.map(i => pieData.labels[i]);
        const filteredValues = filteredIndices.map(i => pieData.values[i]);

        const filteredColors = pieData.marker?.colors
            ? filteredIndices.map(i => pieData.marker.colors[i])
            : undefined;

        const cleanedPieData = {
            ...pieData,
            labels: filteredLabels,
            values: filteredValues,
            marker: {
                ...pieData.marker,
                ...(filteredColors ? { colors: filteredColors } : {})
            }
        };

        timelinePlot.plot_data.data[0] = cleanedPieData;
    }
    return timelinePlot;
}
export function removeNotInDataBar(timelineBarPlotDataTemp){
    if (
        timelineBarPlotDataTemp &&
        timelineBarPlotDataTemp !== undefined &&
        timelineBarPlotDataTemp.plot_data.data &&
        Array.isArray(timelineBarPlotDataTemp.plot_data.data) &&
        Array.isArray(timelineBarPlotDataTemp.plot_data.data) &&
        timelineBarPlotDataTemp.plot_data.data.length > 0
    ) {
        timelineBarPlotDataTemp.plot_data.data = timelineBarPlotDataTemp.plot_data.data.filter(
            (dataset: any) => !(typeof dataset.name === "string" && dataset.name.toUpperCase().includes("NOT IN"))
        );
    }

    return timelineBarPlotDataTemp;
}
